<template>
	<li class="rte">
		<h4 class="hybridlist-item__group-title">
			{{ property.displayName }}
		</h4>
		<ul
			class="hybridlist-item__group-content dont-break-out"
			v-if="
				property.type == propertyTypes.List &&
				getPropertyValueAsList(property.value).length
			"
		>
			<li
				v-for="singleValue in getPropertyValueAsList(property.value)"
				:key="singleValue"
			>
				{{ singleValue }}
			</li>
		</ul>
		<div
			class="rte hybridlist-item__group-content dont-break-out"
			v-else-if="property.type != propertyTypes.Bool && htmlValue != ''"
			v-html="htmlValue"
		></div>
		<div
			class="hybridlist-item__group-content dont-break-out"
			v-else-if="property.type == propertyTypes.Bool"
		>
			{{
				property.value == true
					? translations.Yes
						? translations.Yes
						: "Ja"
					: translations.No
					? translations.No
					: "Nej"
			}}
		</div>
		<span
			class="hybridlist-item__group-content rte dont-break-out empty"
			v-else-if="property.type != propertyTypes.Bool"
			aria-label="Feltet er ikke udfyldt"
		>
		</span>
	</li>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps(["property", "propertyTypes", "translations"]);

const getPropertyValueAsList = (value) => {
	var subValuesArr = value.split("\n");
	var filteredSubValuesArr = subValuesArr.filter(function (el) {
		return el != "";
	});
	return filteredSubValuesArr;
};

const htmlValue = computed(() => {
	if (props.property.value != null) {
		switch (props.property.name.toLowerCase()) {
			case "phone":
				if (props.property.value != 0) {
					return `<a class="inline-link" href="tel:${props.property.value}">${props.property.value}</a>`;
				} else {
					return "";
				}
			case "web":
				if (props.property.value.length) {
					return `<a class="link--internal" target="_blank" href="${props.property.value}">${props.property.value}</a>`;
				} else {
					return props.property.value;
				}
			case "email":
				if (props.property.value.length) {
					return `<a class="inline-link" href="mailto:${props.property.value}">${props.property.value}</a>`;
				} else {
					return props.property.value;
				}
			default:
				return props.property.value;
		}
	} else {
		return props.property.value;
	}
});
</script>
